import { TenantResolution } from './resolveTenant';

/**
 * X-Tenant-Id dev header support: on localhost there is no tenant subdomain,
 * so the backend accepts an explicit `X-Tenant-Id` header in development.
 * Wire this into the api-client via `getExtraHeaders`.
 */
export function tenantHeaders(resolution: TenantResolution, isDev: boolean): Record<string, string> {
  if (isDev && resolution.slug) {
    return { 'X-Tenant-Id': resolution.slug };
  }
  return {};
}
